import { makeStyles } from '@mui/styles';
import { ReactNode } from 'react';

export type StatusPillVariant = 'paid' | 'failed' | 'processing' | 'action';

// Dot-pill palette per Billing 2.0 payment status design.
const PILL_COLORS: Record<StatusPillVariant, { background: string; color: string; dot: string }> = {
  paid: { background: '#EDF8F3', color: '#0B6B4E', dot: '#0F8461' },
  failed: { background: '#FDE7E7', color: '#A73636', dot: '#D14343' },
  processing: { background: '#EEF2F8', color: '#3A4A63', dot: '#5A6B8A' },
  // Declined inline card order awaiting the customer's retry (Purchase Portal 2 [6.10] design)
  action: { background: '#FFF8D6', color: '#5A4A00', dot: '#C99A00' },
};

const useStyles = makeStyles(({
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 11px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flex: 'none',
  },
}));

export const StatusPill = (
  { variant, label }: { variant: StatusPillVariant, label: ReactNode },
) => {
  const classes = useStyles();
  const colors = PILL_COLORS[variant];

  return (
    <span
      className={classes.pill}
      style={{ backgroundColor: colors.background, color: colors.color }}
    >
      <span className={classes.dot} style={{ backgroundColor: colors.dot }} />
      {label}
    </span>
  );
};
